import { render, staticRenderFns } from "./AiPhotoValidationTab.vue?vue&type=template&id=68f00db8&"
import script from "./AiPhotoValidationTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiPhotoValidationTab.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports